import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=488163bb&scoped=true"
import script from "./Wrapper.vue?vue&type=script&lang=ts"
export * from "./Wrapper.vue?vue&type=script&lang=ts"
import style0 from "./Wrapper.vue?vue&type=style&index=0&id=488163bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488163bb",
  null
  
)

export default component.exports